$(function(){
	'use strict';
	if(!$('.admin-logged').length){
		return;
	}
	const FAVORITES_URL='/oblibene/';
	const LIST_API_URL='https://crm.misimame.com/www/api/customer-favorite-items';
	const ADD_API_URL='https://crm.misimame.com/www/api/add-customer-favorite-item';
	const REMOVE_API_URL='https://crm.misimame.com/www/api/remove-customer-favorite-item';
	const API_KEY='50wsrVKxv9I2GsmAD6uy2s3Mwit3aK';

	let favoriteInputTimeout=null;
	let favoritePriceObserver=null;
	let favoritePriceObserverLock=false;

	function currentPath(){
		const path=location.pathname;
		return path;
	}

	function getCustomer(){
		if(typeof getShoptetDataLayer!=='function'){
			return null;
		}

		const customer=getShoptetDataLayer('customer')||null;

		return customer;
	}

	function isRegistered(){
		const customer=getCustomer();
		const registered=!!(customer&&customer.registered);

		return registered;
	}

	function getCustomerEmail(){
		const customer=getCustomer();
		const email=customer&&customer.email?String(customer.email).trim():'';

		return email;
	}

	function getProjectId(){
		if(typeof getShoptetDataLayer!=='function')return '';

		const projectId=getShoptetDataLayer('projectId')||'';

		return projectId;
	}

	function getStorageKey(){
		const key='favorites-'+getProjectId();

		return key;
	}

	function escapeHtml(v){
		return $('<div>').text(v==null?'':v).html();
	}

	function escapeAttr(v){
		return String(v==null?'':v)
			.replace(/&/g,'&amp;')
			.replace(/"/g,'&quot;')
			.replace(/</g,'&lt;')
			.replace(/>/g,'&gt;');
	}

	function slug(v){
		return String(v||'')
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g,'')
			.toLowerCase()
			.replace(/[^a-z0-9]+/g,'-')
			.replace(/^-|-$/g,'');
	}

	function parsePrice(v){
		if(typeof v==='number')return v;
		if(!v)return 0;

		return Number(
			String(v)
				.replace(/\u00a0/g,'')
				.replace(/\s/g,'')
				.replace(/Kč/gi,'')
				.replace(/CZK/gi,'')
				.replace(',','.')
				.replace(/[^\d.]/g,'')
		)||0;
	}

	function formatPrice(v){
		v=Number(v)||0;

		if(typeof v.ShoptetFormatAsCurrency==='function'){
			return v.ShoptetFormatAsCurrency();
		}

		return v.toLocaleString('cs-CZ')+' Kč';
	}

	function stripDescription(html){
		const el=document.createElement('textarea');

		el.innerHTML=String(html||'').replace(/<[^>]*>/g,'');

		let text=el.value.replace(/\s+/g,' ').trim();

		if(text.length>180){
			text=text.substring(0,179);

			const pos=text.lastIndexOf(' ');

			if(pos>0)text=text.substring(0,pos);

			text+='…';
		}

		return text;
	}

	function normalizeCode(v){
		return String(v||'').trim();
	}

	function parseVat(v){
		const n=parseFloat(v);
		return (!isNaN(n)&&n>=0)?n:21;
	}

	function buildApiUrl(base,params){
		return base+'?'+$.param(params);
	}

	/* ============================================================
	 * LOCAL STORAGE
	 * ============================================================ */

	function getLocalFavorites(){
		try{
			const key=getStorageKey();
			const data=localStorage.getItem(key);

			return data?JSON.parse(data):[];
		}catch(e){
			return [];
		}
	}

	function saveLocalFavorites(data){
		try{
			const key=getStorageKey();

			localStorage.setItem(key,JSON.stringify(data||[]));
		}catch(e){
		}
	}

	/* ============================================================
	 * NORMALIZACE DAT
	 * ============================================================ */

	function normalizeCrmProduct(p){
		const standardPrice=parsePrice(p.STANDARD_PRICE);
		const listPrice=parsePrice(p.PRICE);
		const hasCustomerPrice=p.CUSTOMER_PRICE!==null&&typeof p.CUSTOMER_PRICE!=='undefined'&&p.CUSTOMER_PRICE!=='';
		const images=Array.isArray(p.IMAGES)?p.IMAGES.map(String):[];

		const normalized={
			code:normalizeCode(p.CODE),
			name:p.NAME||p.CODE||'',
			description:p.SHORT_DESCRIPTION||'',
			price:hasCustomerPrice?parsePrice(p.CUSTOMER_PRICE):listPrice,
			standardPrice:standardPrice,
			vat:parseVat(p.VAT),
			negativeAmount:Number(p.NEGATIVE_AMOUNT)===1,
			stock:parseFloat(p.STOCK_AMOUNT)||0,
			images:images,
			image:images.length?images[0]:'',
			category:p.CAROVY_KOD||'Ostatní',
			url:p.URL||p.url||''
		};

		return normalized;
	}

	function normalizeLocalProduct(p){
		const images=Array.isArray(p.images)&&p.images.length?p.images.map(String):(p.image?[p.image]:[]);

		return {
			code:normalizeCode(p.product_id||p.code||p.CODE),
			name:p.name||p.NAME||p.product_id||'',
			description:p.description||'',
			price:parsePrice(p.price),
			standardPrice:parsePrice(p.standardPrice),
			vat:parseVat(p.vat),
			negativeAmount:1,
			stock:typeof p.stock!=='undefined'?parseFloat(p.stock)||0:1,
			images:images,
			image:images.length?images[0]:(p.image||''),
			category:p.category||'Ostatní',
			url:p.url||''
		};
	}

	function normalizeIds(items){
		if(!Array.isArray(items))return [];

		return [...new Set(
			items.map(function(item){
				if(typeof item==='string'||typeof item==='number'){
					return normalizeCode(item);
				}

				return normalizeCode(
					item.CODE||
					item.code||
					item.product_id||
					item.productCode||
					''
				);
			}).filter(Boolean)
		)];
	}

	/* ============================================================
	 * FAVORITE SERVICE
	 * ============================================================ */

	const FavoriteService={
		getIds:function(callback){
			if(isRegistered()){
				const email=getCustomerEmail();

				if(!email){
					if(typeof callback==='function')callback([]);

					return;
				}

				$.ajax({
					url:LIST_API_URL,
					method:'GET',
					dataType:'json',
					data:{
						email:email,
						field:'CODE',
						api_key:API_KEY
					},
					success:function(data){
						const products=data&&Array.isArray(data.favorites)?data.favorites:[];
						const ids=normalizeIds(products);

						if(typeof callback==='function')callback(ids);
					},
					error:function(xhr,status,err){
						if(typeof callback==='function')callback([]);
					}
				});

				return;
			}

			const ids=normalizeIds(getLocalFavorites());

			if(typeof callback==='function')callback(ids);
		},

		add:function(code,productData,callback){
			code=normalizeCode(code);

			if(!code){
				if(typeof callback==='function')callback(false);

				return;
			}

			if(isRegistered()){
				const email=getCustomerEmail();

				if(!email){
					if(typeof callback==='function')callback(false);

					return;
				}

				$.ajax({
					url:buildApiUrl(ADD_API_URL,{
						email:email,
						productCode:code,
						api_key:API_KEY
					}),
					method:'POST',
					dataType:'json',
					success:function(data){
						$(document).trigger('FavoriteChanged');

						if(typeof callback==='function')callback(true);
					},
					error:function(xhr,status,err){
						if(typeof callback==='function')callback(false);
					}
				});

				return;
			}

			let favorites=getLocalFavorites();

			const exists=favorites.some(function(item){
				return normalizeCode(item.product_id||item.code||item.CODE)===code;
			});

			if(!exists){
				console.log(productData)
			favorites.push({
				product_id:code,
				name:productData.name||'',
				image:productData.image||'',
				images:Array.isArray(productData.images)&&productData.images.length?productData.images:(productData.image?[productData.image]:[]),
				price:productData.price||'',
				standardPrice:productData.standardPrice||'',
				stock:typeof productData.stock!=='undefined'?productData.stock:1,
				url:productData.url||'',
				category:productData.category||'Ostatní',
				description:productData.description||''
			});

				saveLocalFavorites(favorites);
			}

			$(document).trigger('FavoriteChanged');

			if(typeof callback==='function')callback(true);
		},

		remove:function(code,callback){
			code=normalizeCode(code);

			if(!code){
				if(typeof callback==='function')callback(false);
				return;
			}

			if(isRegistered()){
				const email=getCustomerEmail();

				if(!email){
					if(typeof callback==='function')callback(false);
					return;
				}

				$.ajax({
					url:buildApiUrl(REMOVE_API_URL,{
						email:email,
						productCode:code,
						api_key:API_KEY
					}),
					method:'DELETE',
					dataType:'json',
					success:function(data){
						$(document).trigger('FavoriteChanged');

						if(typeof callback==='function')callback(true);
					},
					error:function(xhr,status,err){
						if(typeof callback==='function')callback(false);
					}
				});

				return;
			}

			let favorites=getLocalFavorites();

			favorites=favorites.filter(function(item){
				return normalizeCode(item.product_id||item.code||item.CODE)!==code;
			});

			saveLocalFavorites(favorites);

			$(document).trigger('FavoriteChanged');

			if(typeof callback==='function')callback(true);
		},

		getCount:function(callback){
			this.getIds(function(ids){
				if(typeof callback==='function')callback(ids.length);
			});
		}
	};

	window.FavoriteService=FavoriteService;

	/* ============================================================
	 * FAVORITE ICON
	 * ============================================================ */

	function renderFavoriteIcon(){
		if($('.favorite_icon_new').length){
			return;
		}

		const $targets=$('header#header .navigation-buttons,.responsive-tools');

		$targets.append(
			'<a href="'+FAVORITES_URL+'" data-target="favorite" class="favorite">'+
				'<i class="favorite_icon_new" data-count="0">0</i>'+
			'</a>'
		);
	}

	function loadFavoriteNumber(){
		FavoriteService.getCount(function(count){
			$('.favorite_icon_new')
				.text(count)
				.attr('data-count',count);
		});
	}

	/* ============================================================
	 * PRODUCT ID / DATA
	 * ============================================================ */

	function getDetailProductIds(){
		if(typeof getShoptetDataLayer!=='function'){
			return [];
		}

		const product=getShoptetDataLayer('product')||{};
		const codes=Array.isArray(product.codes)?product.codes:[];

		const ids=normalizeIds(codes.map(function(item){
			return item.code;
		}));

		return ids;
	}

	function getCardProductCode($product){
		const code=normalizeCode(
			$product.attr('data-favorite-code')||
			$product.find('[data-micro="sku"]').first().text()||
			$product.find('.p-code').first().text().replace('Kód:','')
		);

		return code;
	}

	function getProductData($btn){
		if($('.type-detail').length){
			const $context=$('.p-info-wrapper');
			const $img=$('.p-image-wrapper .p-image img').first();
			const mainImage=$img.attr('src')||'';
			const hoverImage=$img.attr('data-next')||'';
			const availabilityText=$context.find('.availability').first().text().trim();

			const data={
				name:$context.find('.h1').first().text().trim(),
				image:mainImage,
				images:[mainImage,hoverImage].filter(Boolean),
				price:$context.find('.price-final-holder').first().text().trim(),
				standardPrice:$context.find('.price-standard').first().text().trim(),
				stock:/Není skladem/i.test(availabilityText)?0:1,
				url:document.location.href,
				category:'Ostatní'
			};

			return data;
		}

		const $product=$btn.closest('.product');
		const $img=$product.find('.image img').first();
		const mainImage=$img.attr('src')||'';
		const hoverImage=$img.attr('data-next')||'';
		const availabilityText=$product.find('.availability').first().text().trim();

		const data={
			name:$product.find('a.name').first().text().trim(),
			image:mainImage,
			images:[mainImage,hoverImage].filter(Boolean),
			price:$product.find('.price-final,.price').first().text().trim(),
			standardPrice:$product.find('.price-standard').first().text().trim(),
			stock:/Není skladem/i.test(availabilityText)?0:1,
			url:$product.find('a.name').first().attr('href')||'',
			category:$product.closest('.favorite-section').find('h2').first().text().trim()||'Ostatní',
			description:$product.find('.p-desc[data-micro="description"]').first().text().trim()|| ''
		};

		return data;
	}

	/* ============================================================
	 * FAVORITE BUTTONS
	 * ============================================================ */

	function renderFavoriteButtons(){
		if($('.type-detail').length){
			if($('.add-to-favorites').length){
				return;
			}

			const ids=getDetailProductIds();

			if(!ids.length){
				return;
			}

			const $target=$('.p-info-wrapper');

			$target.append(
				'<div class="customFavorite">'+
					'<span class="add-to-favorites" data-id="'+escapeAttr(ids[0])+'" data-ids=\''+escapeAttr(JSON.stringify(ids))+'\'>'+
						'Přidat do oblíbených'+
					'</span>'+
				'</div>'
			);

			return;
		}

		if(currentPath()===FAVORITES_URL){
			return;
		}

		const $products=$('.products .product');

		$products.each(function(){
			const $product=$(this);

			if($product.find('.add-to-favorites').length)return;

			const code=getCardProductCode($product);

			if(!code){
				return;
			}

			$product.find('.p').append(
				'<div class="customFavorite">'+
					'<span class="add-to-favorites" data-id="'+escapeAttr(code)+'" data-ids=\'["'+escapeAttr(code)+'"]\'>'+
						'Přidat do oblíbených'+
					'</span>'+
				'</div>'
			);
		});
	}

	function refreshFavoriteButtons(){
		FavoriteService.getIds(function(favoriteIds){
			$('.add-to-favorites').each(function(){
				const $btn=$(this);

				let ids=[];

				try{
					ids=JSON.parse($btn.attr('data-ids')||'[]');
				}catch(e){
					ids=[];
				}

				ids=ids.map(normalizeCode);

				const isFavorite=ids.some(function(id){
					return favoriteIds.includes(id);
				});

				$btn
					.toggleClass('in-favorites',isFavorite)
					.text(
						isFavorite
							?'Odebrat z oblíbených'
							:'Přidat do oblíbených'
					);
			});
		});
	}

	$(document).on('click','.add-to-favorites',function(e){
		e.preventDefault();

		const $btn=$(this);

		if($btn.hasClass('favorite-loading')){
			return;
		}

		let ids=[];

		try{
			ids=JSON.parse($btn.attr('data-ids')||'[]');
		}catch(e){
			ids=[];
		}

		if(!ids.length){
			const id=normalizeCode($btn.attr('data-id'));

			if(id)ids=[id];
		}

		ids=ids.map(normalizeCode).filter(Boolean);

		if(!ids.length){
			return;
		}

		const removing=$btn.hasClass('in-favorites');
		const productData=getProductData($btn);

		$btn.addClass('favorite-loading');

		let finished=0;
		let success=true;

		function done(){
			finished++;

			if(finished<ids.length)return;

			$btn.removeClass('favorite-loading');

			if(!success){
				return;
			}

			const newState=!removing;

			$btn
				.toggleClass('in-favorites',newState)
				.text(
					newState
						?'Odebrat z oblíbených'
						:'Přidat do oblíbených'
				);

			const $product=$btn.closest('.product');

			showFavoriteCartMessage(
				$product,
				newState
					?'Přidáno do oblíbených'
					:'Odebráno z oblíbených',
				newState
					?'addtocart'
					:'removetocart'
			);

			loadFavoriteNumber();

			if(removing&&currentPath()===FAVORITES_URL){
				const $product=$btn.closest('.product');

				setTimeout(function(){
					$product.fadeOut(200,function(){
						$(this).remove();
						removeEmptyFavoriteSections();
					});
				},2500);
			}
		}

		ids.forEach(function(code){
			if(removing){
				FavoriteService.remove(code,function(ok){
					if(!ok)success=false;
					done();
				});
			}else{
				FavoriteService.add(code,productData,function(ok){
					if(!ok)success=false;
					done();
				});
			}
		});
	});

	/* ============================================================
	 * FAVORITES PAGE
	 * ============================================================ */

	function initFavoritesPage(){
		const $container=$('div[itemprop="about"]');

		if(!$container.length){
			return;
		}

		$('main#content div.content-inner').css({
			maxWidth:'100%',
			width:'100%'
		});

		$container.html(
			'<div id="favorite-items">'+
				'<div class="favorites-loading">Načítám oblíbené položky…</div>'+
			'</div>'
		);

		if(isRegistered()){
			loadRegisteredFavoriteProducts();
		}else{
			loadLocalFavoriteProducts();
		}
	}

	function loadRegisteredFavoriteProducts(){
		const email=getCustomerEmail();
		const $favorites=$('#favorite-items');

		if(!email){
			$favorites.html('<p>Nepodařilo se zjistit přihlášeného zákazníka.</p>');

			return;
		}

		const requestData={
			email:email,
			field:'CODE,NAME,SHORT_DESCRIPTION,PRICE,STANDARD_PRICE,ACTION_PRICE,STOCK_AMOUNT,IMAGES,CAROVY_KOD,NEGATIVE_AMOUNT,URL,CUSTOMER_PRICE,VAT',
			api_key:API_KEY
		};

		$.ajax({
			url:LIST_API_URL,
			method:'GET',
			dataType:'json',
			data:requestData,

			success:function(data){
				const source=data&&Array.isArray(data.favorites)?data.favorites:[];

				const products=source.map(normalizeCrmProduct);

				renderFavoritesPage(products);
			},

			error:function(xhr,status,err){
				$favorites.html('<p>Oblíbené položky se nepodařilo načíst.</p>');
			}
		});
	}

	function loadLocalFavoriteProducts(){
		const source=getLocalFavorites();

		const products=source.map(normalizeLocalProduct);

		renderFavoritesPage(products);
	}

	function renderFavoritesPage(products){
		const $favorites=$('#favorite-items');

		if(!$favorites.length){
			return;
		}

		if(!products.length){
			$favorites.html(
				'<p>'+
					(typeof translation==='function'
						?'V oblíbených nemáte žádné položky'
						:'Nemáte žádné oblíbené položky.')+
				'</p>'
			);

			return;
		}

		const groups={};

		products.forEach(function(product){
			const category=$.trim(product.category||'Ostatní');

			if(!groups[category])groups[category]=[];

			groups[category].push(product);
		});

		let nav='<div class="favorite-nav">';
		let sections='';

		$.each(groups,function(name,items){
			const id='fav-'+slug(name);

			nav+='<a href="#'+escapeAttr(id)+'">'+escapeHtml(name)+'</a>';

			sections+=
				'<section class="favorite-section" id="'+escapeAttr(id)+'">'+
					'<h2>'+escapeHtml(name)+'</h2>'+
					'<div class="products products-page products-block favoriteProductsGrid" data-testid="productCards">';

			items.forEach(function(product){
				sections+=renderFavoriteProduct(product);
			});

			sections+='</div></section>';
		});

		nav+='</div>';

		$favorites.html(nav+sections);

		syncFavoriteCart();
		updateAllFavoriteTotals();
		startFavoritePriceObserver();
	}

	function renderFavoriteProduct(p){
		function toDetailImage(url){
			url=String(url||'');
			return url.indexOf('/orig/')!==-1?url.replace('/orig/','/detail/'):url;
		}

		const images=Array.isArray(p.images)&&p.images.length?p.images:(p.image?[p.image]:[]);
		const mainImage=toDetailImage(images[0]||'');
		const hoverImage=images[1]?toDetailImage(images[1]):'';
		console.log(p)
		const code=p.code||'';
		const name=p.name||code;
		const price=parsePrice(p.price);
		const standardPrice=parseFloat(p.standardPrice)||0;
		const hasDiscount=standardPrice>0&&standardPrice>price;
		const discountPercent=hasDiscount?Math.round((1-price/standardPrice)*100):0;
		const stock=parseFloat(p.stock)||0;
		const inStock=!!p.negativeAmount||stock>0;
		const description=stripDescription(p.description||'');
		const availability=inStock?'https://schema.org/InStock':'https://schema.org/OutOfStock';
		const vat=parseVat(p.vat);
		const vatPrice=price*(1+vat/100);

		return '<div class="product" data-favorite-code="'+escapeAttr(code)+'" data-favorite-price="'+price+'">'+
			'<div class="p swap-images" data-micro="product" data-testid="productItem">'+

				'<a href="'+escapeAttr(p.url||'#')+'" class="image favoriteProductImage">'+
					(mainImage?'<img src="'+escapeAttr(mainImage)+'" alt="'+escapeAttr(name)+'" data-src="'+escapeAttr(mainImage)+'"'+(hoverImage?' data-next="'+escapeAttr(hoverImage)+'" class="swap-image"':'')+' data-micro-image="'+escapeAttr(mainImage)+'" loading="lazy">':'')+
					(hasDiscount
						?'<div class="flags flags-extra">'+
							'<span class="flag flag-discount">'+
								'<span class="price-standard"><span>'+escapeHtml(formatPrice(standardPrice))+'</span></span>'+
								'<span class="price-save">–'+discountPercent+' %</span>'+
							'</span>'+
						'</div>'+
						'<span class="price-standard"><span>'+escapeHtml(formatPrice(standardPrice))+'</span></span>'
						:'')+
				'</a>'+

				'<div class="p-in">'+

					'<div class="p-in-in">'+
						'<a href="'+escapeAttr(p.url||'#')+'" class="name" data-micro="url">'+
							'<span data-micro="name" data-testid="productCardName">'+escapeHtml(name)+'</span>'+
						'</a>'+
					'</div>'+

					'<div class="p-bottom single-button favoriteProductDefault">'+
						'<div data-micro="offer" data-micro-price="'+price+'" data-micro-price-currency="CZK" data-micro-availability="'+availability+'">'+

							'<div class="prices">'+
								(hasDiscount?'<span class="price-standard"><span>'+escapeHtml(formatPrice(standardPrice))+'</span></span>':'')+
								'<div class="price-additional">'+escapeHtml(formatPrice(vatPrice))+'&nbsp;s DPH</div>'+
								'<div class="price price-final" data-testid="productCardPrice">'+
									'<strong>'+escapeHtml(formatPrice(price))+'</strong>'+
								'</div>'+
								'<div class="availability">'+
									'<span style="'+(inStock?'color:#65B741':'color:#cb0000')+'">'+(inStock?'Skladem':'Není skladem')+'</span>'+
								'</div>'+
							'</div>'+

							'<div class="p-tools">'+
								'<span class="favoriteCartOpen btn btn-cart add-to-cart-button">Do košíku</span>'+
							'</div>'+

							(description
								?'<p class="p-desc" data-micro="description" data-testid="productCardShortDescr">'+escapeHtml(description)+'</p>'
								:'')+

						'</div>'+
					'</div>'+

					'<div class="productPairs favoriteProductPairs" style="display:none;">'+
						'<div class="productPairsList favoritePairsList">'+

							'<div class="mobilePackageInfo">'+
								'<div class="mobilePackageInfoItem" data-package-index="0">'+
									'<span class="mobilePackageLeft">ks</span>'+
									'<span class="mobilePackageEqual">=</span>'+
									'<span class="mobilePackageAmount">1</span>'+
									'<span class="mobilePackageRight">ks</span>'+
								'</div>'+
							'</div>'+

							'<div class="commonLine" data-unit="ks" data-package-index="0">'+
								'<div class="left">'+
									'<div class="lineIt">ks = 1 ks</div>'+
								'</div>'+

								'<div class="right">'+
									'<form action="'+escapeAttr(shoptet.config.updateCartUrl)+'" method="post" class="quantity-form js-quantity-form csrf-enabled favoriteAmountForm" data-code="'+escapeAttr(code)+'" data-price-id="" data-item-id="" data-unit-price="'+price+'" data-current-amount="0">'+

										'<input type="hidden" name="itemId" value="">'+
										'<input type="hidden" name="priceId" value="">'+

										'<button type="button" class="amountMinus favoriteAmountMinus" aria-label="Snížit množství">−</button>'+

										'<div class="amountInputWrap">'+
											'<input type="number" name="amount" class="amount amountInput favoriteAmountInput" value="0" min="0" step="1" autocomplete="off" inputmode="numeric" data-decimals="0">'+
											'<span class="amountUnit">ks</span>'+
										'</div>'+

										'<button type="button" class="amountPlus favoriteAmountPlus" aria-label="Zvýšit množství">+</button>'+

									'</form>'+
								'</div>'+
							'</div>'+

							'<div class="commnotPriceBottom">'+
								'<span class="pc">Cena celkem</span> '+
								'<span class="mobile">Celkem bez DPH</span>: '+
								'<span class="countPrice">'+formatPrice(0)+'</span>'+
							'</div>'+

						'</div>'+
					'</div>'+

					'<div class="customFavorite">'+
						'<span class="add-to-favorites in-favorites" data-id="'+escapeAttr(code)+'" data-ids=\'["'+escapeAttr(code)+'"]\'>'+
							(typeof translation==='function'
								?'Odebrat z oblíbených'
								:'Odebrat z oblíbených')+
						'</span>'+
					'</div>'+

				'</div>'+

				'<span class="p-code">Kód: <span data-micro="sku">'+escapeHtml(code)+'</span></span>'+
			'</div>'+

			'<span class="btn_toggle"></span>'+
		'</div>';
	}

	function removeEmptyFavoriteSections(){
		$('.favorite-section').each(function(){
			const $section=$(this);

			if(!$section.find('.product').length){
				const id=$section.attr('id');

				$('.favorite-nav a[href="#'+id+'"]').remove();
				$section.remove();
			}
		});

		if(!$('#favorite-items .product').length){
			$('#favorite-items').html(
				'<p>'+
					(typeof translation==='function'
						?'V oblíbených nemáte žádné položky'
						:'Nemáte žádné oblíbené položky.')+
				'</p>'
			);
		}
	}

	/* ============================================================
	 * CART
	 * ============================================================ */

	function getCartItems(){
		if(typeof getShoptetDataLayer!=='function')return [];

		const cart=getShoptetDataLayer('cart');

		return Array.isArray(cart)?cart:[];
	}

	function findCartItem(code,items){
		code=normalizeCode(code);

		return items.find(function(item){
			return normalizeCode(item.code)===code;
		})||null;
	}

	function updateFavoriteTotal($form){
		const $product=$form.closest('.product[data-favorite-code]');
		const amount=parseInt($form.find('.favoriteAmountInput').val(),10)||0;
		const price=parseFloat($product.attr('data-favorite-price'))||0;
		const expected=formatPrice(amount*price);
		const $count=$product.find('.favoritePairsList .countPrice').first();

		if($count.text().trim()!==expected){
			$count.text(expected);
		}
	}

	function updateAllFavoriteTotals(){
		$('#favorite-items .favoriteAmountForm').each(function(){
			updateFavoriteTotal($(this));
		});
	}

	function updateFavoriteRemoveButton($product){
		const $form=$product.find('.favoriteAmountForm').first();

		if(!$form.length)return;

		const amount=parseInt($form.find('.favoriteAmountInput').val(),10)||0;
		const pending=$form.attr('data-pending')||'';
		const $icon=$product.find('.favoriteRemoveFromCart');

		if(amount>0||pending==='add'){
			if(!$icon.length){
				$product.find('.p').append(
					'<span class="removeProductPairsGroup favoriteRemoveFromCart" title="Odebrat z košíku" aria-label="Odebrat z košíku"></span>'
				);
			}
		}
	}

	function updateFavoriteState($form){
		const amount=parseInt($form.find('.favoriteAmountInput').val(),10)||0;
		const $product=$form.closest('.product[data-favorite-code]');
		const $line=$form.closest('.commonLine');
		const $pairs=$form.closest('.favoriteProductPairs');

		$line.toggleClass('activeLine',amount>0);
		$pairs.toggleClass('hasActiveLine',amount>0);

		$product
			.find('.mobilePackageInfoItem[data-package-index="'+$line.attr('data-package-index')+'"]')
			.toggleClass('activeLine',amount>0);

		updateFavoriteTotal($form);
		updateFavoriteRemoveButton($product);
	}

	function setFavoriteVisibleState($product){
		const $form=$product.find('.favoriteAmountForm').first();

		if(!$form.length)return;

		const amount=parseInt($form.find('.favoriteAmountInput').val(),10)||0;
		const itemId=String($form.find('[name="itemId"]').val()||'').trim();
		const pending=$form.attr('data-pending')||'';

		if(amount>0&&(itemId||pending==='add')){
			$product.find('.favoriteProductDefault').hide();
			$product.find('.favoriteProductPairs').show();
		}else{
			$product.find('.favoriteProductPairs').hide();
			$product.find('.favoriteProductDefault').show();
		}
	}

	function syncFavoriteCart(){
		const items=getCartItems();

		$('#favorite-items .favoriteAmountForm').each(function(){
			const $form=$(this);
			const $product=$form.closest('.product[data-favorite-code]');
			const code=normalizeCode($form.attr('data-code'));
			const item=findCartItem(code,items);
			const pending=$form.attr('data-pending')||'';

			if(pending==='add'&&!item){
				updateFavoriteState($form);
				return;
			}

			if(pending==='remove'&&item){
				updateFavoriteState($form);
				return;
			}

			if(item){
				const quantity=parseInt(item.quantity,10)||0;

				$form.removeAttr('data-pending');

				$form.attr({
					'data-item-id':item.itemId||'',
					'data-price-id':item.priceId||'',
					'data-current-amount':quantity
				});

				$form.find('[name="itemId"]').val(item.itemId||'');
				$form.find('[name="priceId"]').val(item.priceId||'');
				$form.find('.favoriteAmountInput').val(quantity);
			}else{
				if(pending==='add')return;

				$form.removeAttr('data-pending');

				$form.attr({
					'data-item-id':'',
					'data-price-id':'',
					'data-current-amount':0
				});

				$form.find('[name="itemId"]').val('');
				$form.find('[name="priceId"]').val('');
				$form.find('.favoriteAmountInput').val(0);

				$product.find('.favoriteRemoveFromCart').remove();
			}

			updateFavoriteState($form);
			setFavoriteVisibleState($product);
		});

		updateAllFavoriteTotals();
	}

	function changeFavoriteAmount($form,newAmount){
		const code=normalizeCode($form.attr('data-code'));
		const oldAmount=parseInt($form.attr('data-current-amount'),10)||0;
		const itemId=String($form.find('[name="itemId"]').val()||'').trim();
		const priceId=String($form.find('[name="priceId"]').val()||'').trim();
		const $product=$form.closest('.product[data-favorite-code]');

		newAmount=parseInt(newAmount,10);

		if(isNaN(newAmount)||newAmount<0)newAmount=0;

		$form.find('.favoriteAmountInput').val(newAmount);
		$form.attr('data-current-amount',newAmount);

		updateFavoriteState($form);

		if(!itemId&&newAmount>0){
			$form.attr('data-pending','add');

			updateFavoriteState($form);
			setFavoriteVisibleState($product);

			shoptet.cartShared.addToCart({
				productCode:code,
				amount:newAmount
			},true);

			showFavoriteCartMessage($product,'Přidáno do košíku','addtocart');

			return;
		}

		if(!itemId&&newAmount===0){
			$form.removeAttr('data-pending');

			updateFavoriteState($form);
			setFavoriteVisibleState($product);

			return;
		}

		if(itemId&&newAmount===0){
			$form.attr('data-pending','remove');

			shoptet.cartShared.removeFromCart({
				itemId:itemId
			},true);

			$form.attr('data-current-amount',0);
			$form.find('.favoriteAmountInput').val(0);

			updateFavoriteState($form);

			$product.find('.favoriteProductPairs').stop(true,true).slideUp(200);
			$product.find('.favoriteProductDefault').show();

			showFavoriteCartMessage($product,'Odebráno z košíku','removetocart');

			return;
		}

		if(itemId&&priceId){
			shoptet.cartShared.updateQuantityInCart({
				itemId:itemId,
				priceId:priceId,
				amount:newAmount
			});

			if(newAmount>oldAmount){
				showFavoriteCartMessage($product,'Přidáno do košíku','addtocart');
			}else if(newAmount<oldAmount){
				showFavoriteCartMessage($product,'Odebráno z košíku','removetocart');
			}
		}
	}

	function showFavoriteCartMessage($product,message,css){
		$product.find('.favoriteCartMessage').remove();

		const $msg=$('<div class="cartMessage favoriteCartMessage"></div>')
			.text(message)
			.addClass(css||'');

		$product.append($msg);

		setTimeout(function(){
			$msg.addClass('isVisible');
		},10);

		setTimeout(function(){
			$msg.removeClass('isVisible');

			setTimeout(function(){
				$msg.remove();
			},500);
		},500);
	}

	/* ============================================================
	 * CART HANDLERS
	 * ============================================================ */

	$(document).on('click','.favoriteCartOpen',function(e){
		e.preventDefault();
		e.stopImmediatePropagation();

		const $product=$(this).closest('.product[data-favorite-code]');

		$product.find('.productPairs').slice(1).remove();

		const $form=$product.find('.favoriteAmountForm').first();

		if(!$form.length)return;
		if($form.attr('data-pending'))return;

		$product.find('.favoriteProductDefault').hide();
		$product.find('.favoriteProductPairs').stop(true,true).slideDown(200);

		changeFavoriteAmount($form,1);
	});

	$(document).on('click','.favoriteAmountPlus',function(){
		const $form=$(this).closest('.favoriteAmountForm');

		if($form.attr('data-pending'))return;

		const amount=parseInt($form.find('.favoriteAmountInput').val(),10)||0;

		changeFavoriteAmount($form,amount+1);
	});

	$(document).on('click','.favoriteAmountMinus',function(){
		const $form=$(this).closest('.favoriteAmountForm');

		if($form.attr('data-pending'))return;

		const amount=parseInt($form.find('.favoriteAmountInput').val(),10)||0;

		if(amount<=0)return;

		changeFavoriteAmount($form,amount-1);
	});

	$(document).on('input change','.favoriteAmountInput',function(){
		const $input=$(this);
		const $form=$input.closest('.favoriteAmountForm');

		if($form.attr('data-pending'))return;

		let value=parseInt($input.val(),10);

		if(isNaN(value)||value<0)value=0;

		$input.val(value);
		updateFavoriteState($form);

		clearTimeout(favoriteInputTimeout);

		favoriteInputTimeout=setTimeout(function(){
			changeFavoriteAmount($form,value);
		},500);
	});

	$(document).on('click','.favoriteRemoveFromCart',function(e){
		e.preventDefault();

		const $product=$(this).closest('.product[data-favorite-code]');
		const $form=$product.find('.favoriteAmountForm').first();

		if(!$form.length)return;
		if($form.attr('data-pending'))return;

		const itemId=String($form.find('[name="itemId"]').val()||'').trim();

		if(!itemId)return;

		$form.attr('data-pending','remove');

		shoptet.cartShared.removeFromCart({
			itemId:itemId
		},true);

		$form.attr('data-current-amount',0);
		$form.find('.favoriteAmountInput').val(0);

		updateFavoriteState($form);

		$product.find('.favoriteProductPairs').stop(true,true).slideUp(200);
		$product.find('.favoriteProductDefault').show();

		showFavoriteCartMessage($product,'Odebráno z košíku','removetocart');
	});

	/* ============================================================
	 * PRICE OBSERVER
	 * ============================================================ */

	function startFavoritePriceObserver(){
		const $favorites=$('#favorite-items');

		if(!$favorites.length)return;

		if(favoritePriceObserver){
			favoritePriceObserver.disconnect();
		}

		favoritePriceObserver=new MutationObserver(function(mutations){
			if(favoritePriceObserverLock)return;

			let update=false;

			mutations.forEach(function(mutation){
				const $target=$(mutation.target);

				if(
					$target.hasClass('countPrice')||
					$target.closest('.commnotPriceBottom').length||
					$target.hasClass('commnotPriceBottom')
				){
					update=true;
				}

				if(!update&&mutation.addedNodes&&mutation.addedNodes.length){
					$(mutation.addedNodes).each(function(){
						const $node=$(this);

						if(
							$node.is('.countPrice,.commnotPriceBottom')||
							$node.find('.countPrice,.commnotPriceBottom').length
						){
							update=true;
							return false;
						}
					});
				}
			});

			if(!update)return;

			requestAnimationFrame(function(){
				favoritePriceObserverLock=true;
				updateAllFavoriteTotals();
				favoritePriceObserverLock=false;
			});
		});

		favoritePriceObserver.observe($favorites[0],{
			subtree:true,
			childList:true,
			characterData:true
		});
	}

	/* ============================================================
	 * SHOPTET EVENTS
	 * ============================================================ */

	document.addEventListener('ShoptetDataLayerUpdated',function(){
		if(currentPath()===FAVORITES_URL){
			syncFavoriteCart();

			requestAnimationFrame(function(){
				updateAllFavoriteTotals();
			});
		}
	});

	[
		'ShoptetDOMPageContentLoaded',
		'ShoptetDOMPageMoreProductsLoaded',
		'ShoptetPageSortingChanged'
	].forEach(function(eventName){
		document.addEventListener(eventName,function(){
			if(currentPath()===FAVORITES_URL)return;

			renderFavoriteButtons();
			refreshFavoriteButtons();
		});
	});

	/* ============================================================
	 * INIT
	 * ============================================================ */

	function initFavorites(){
		renderFavoriteIcon();
		loadFavoriteNumber();

		const path=currentPath();

		if(path===FAVORITES_URL){
			initFavoritesPage();

			return;
		}

		renderFavoriteButtons();
		refreshFavoriteButtons();
	}

	$(document).on('FavoriteChanged',function(){
		loadFavoriteNumber();
	});

	try{
		initFavorites();
	}catch(e){}
});